module.exports = __webpack_public_path__ + "assets/img/news-25-logo.3a19871f.jpg";